import { TECHNOLOGY_CATEGORIES } from "../constants";

export interface TechItem {
  nombre: string;
  logo: string;
}

export interface CategoriaTecnologia {
  titulo: string;
  tecnologias: TechItem[];
}

export const tecnologia = TECHNOLOGY_CATEGORIES;
